import {
  PRODUCT_DETAILS,
  WISHLIST_SAVE,
  SELECT_MY_LIST,
  CLOSE,
  SAVE_TO_LIST,
  SAVE_TO_LIST_GUEST,
} from "@/components/SaveToList/constant"
const pushToAdobeDataLayer = (eventInfo, productInfo) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    ...(productInfo ? { productInfo } : {}),
    page,
  })
}

const getPageType = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const pageType = page?.category?.pageType ?? "pdp"
  return pageType
}

export const dataLayerSavetolistGuest = productInfo => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST_GUEST?.toLowerCase()}`,
    eventMsg: "n/a",
    eventName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST_GUEST?.toLowerCase()}`,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${SAVE_TO_LIST}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST?.toLowerCase()}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST?.toLowerCase()}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const dataLayerHeartClickSaveListButton = (
  productInfo,
  headerTitle,
  eventType
) => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${headerTitle?.toLowerCase()}`,
    eventMsg: "n/a",
    eventName: `${pageType}:${PRODUCT_DETAILS}:${headerTitle?.toLowerCase()}`,
    eventStatus: "n/a",
    eventType: eventType,
    internalLinkName: `${headerTitle?.toLowerCase()}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${headerTitle?.toLowerCase()}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${headerTitle?.toLowerCase()}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const dataLayerCreateNewListButton = (
  productInfo,
  createNewListTitle
) => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}`,
    eventMsg: "n/a",
    eventName: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}`,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${createNewListTitle?.toLowerCase()}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const dataLayerMyListSaveListButton = (
  productInfo,
  selectedData = "",
  successDesc = "",
  successTitle
) => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${SELECT_MY_LIST}:${successTitle?.toLowerCase()}`,
    eventMsg: `${successDesc}`,
    eventName: `${pageType}:${PRODUCT_DETAILS}:${SELECT_MY_LIST}:${successTitle?.toLowerCase()}`,
    eventStatus: `${successTitle?.toLowerCase()}`,
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${selectedData}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}:${selectedData}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const dataLayerCreateNewSaveListButton = (
  productInfo,
  createListData = "",
  successDesc = "",
  createNewListTitle,
  successTitle
) => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}:${successTitle?.toLowerCase()}`,
    eventMsg: `${successDesc}`,
    eventName: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}:${successTitle?.toLowerCase()}`,
    eventStatus: `${successTitle?.toLowerCase()}`,
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${createListData}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}:${createListData}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const closeSaveToListAnalytics = productInfo => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}:${CLOSE}`,
    eventMsg: "n/a",
    eventName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}:${CLOSE}`,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${CLOSE}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const closeCreateNewListAnalytics = (
  productInfo,
  createNewListTitle
) => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}:${CLOSE}`,
    eventMsg: "n/a",
    eventName: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}:${CLOSE}`,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${CLOSE}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const closeCreateNewListSuccessAnalytics = (
  productInfo,
  createListData = "",
  createNewListTitle,
  successTitle
) => {
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}:${successTitle?.toLowerCase()}:${CLOSE}`,
    eventMsg: "n/a",
    eventName: `${pageType}:${PRODUCT_DETAILS}:${createNewListTitle?.toLowerCase()}:${successTitle?.toLowerCase()}:${CLOSE}`,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${CLOSE}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}:${createListData}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}

export const closeSelectMyListAnalytics = (
  productInfo,
  selectedData = "",
  successTitle = null
) => {
  const pageType = getPageType()
  const eventPath = `${pageType}:${PRODUCT_DETAILS}:${SELECT_MY_LIST}`
  const eventData = successTitle
    ? `${eventPath}:${successTitle}:${CLOSE}`
    : `${eventPath}:${CLOSE}`

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: eventData,
    eventMsg: "n/a",
    eventName: eventData,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${CLOSE}`,
    internalLinkPosition: `${pageType}`,
    internalLinkType: `${pageType}:${SAVE_TO_LIST}:${selectedData}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:${PRODUCT_DETAILS}:${SAVE_TO_LIST}`,
  }
  pushToAdobeDataLayer(eventInfo, productInfo)
}
